module.exports = __webpack_public_path__ + "static/media/paluba.15929d5f.jpg";